import { GET_CONCRETE_CLASSES_100_REQUEST } from './types';

const getConcreteClasses100 = (payload) => ({
  type: GET_CONCRETE_CLASSES_100_REQUEST,
  payload,
});

export { getConcreteClasses100 };
